import USER_ROLES from 'constants/UserRoles';
export const isAdmin = (user) => {
    return user._type === 'Admin';
};
export const isFinanceAdmin = (user) => {
    return ((user.roles && user.roles.includes(USER_ROLES.FINANCE_ADMIN)) ||
        (user.roles &&
            user.roles.includes(USER_ROLES.FINANCE) &&
            (user.roles.includes(USER_ROLES.ACCOUNT_ADMIN) || USER_ROLES.GOD)));
};
export const isShipper = (user) => {
    return user._type === 'Shipper';
};
export const isCarrier = (user) => {
    return user._type === 'Carrier';
};
